import { render, staticRenderFns } from "./AbbReceipt-6-680.vue?vue&type=template&id=f18c61c8&lang=pug&"
import script from "./AbbReceipt-6-680.vue?vue&type=script&lang=js&"
export * from "./AbbReceipt-6-680.vue?vue&type=script&lang=js&"
import style0 from "./AbbReceipt-6-680.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports